import apiNtzTemplate from '@/api/ntz-template'

const state = {
  data: [],
  total: 0,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getNtzTemplateStart: '[ntz template] Get training template start',
  getNtzTemplateSuccess: '[ntz template] Get ntz template success',
  getNtzTemplateFailure: '[ntz template] Get ntz template failure',

  getNtzTemplateSchoolIdStart: '[ntz template] Get ntz template schoolId start',
  getNtzTemplateSchoolIdSuccess:
    '[ntz template] Get ntz template schoolId success',
  getNtzTemplateSchoolIdFailure:
    '[ntz template] Get ntz template schoolId failure',
}

export const actionTypes = {
  getNtzTemplate: '[ntz template] Get ntz template',
  getNtzTemplateSchoolId: '[ntz template] Get ntz template schoolId',
}

const mutations = {
  [mutationTypes.getNtzTemplateStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getNtzTemplateSuccess](state, payload) {
    state.data = payload

    state.isLoading = false
  },

  [mutationTypes.getNtzTemplateFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getNtzTemplateSchoolIdStart](state) {
    state.total = 0
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getNtzTemplateSchoolIdSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getNtzTemplateSchoolIdFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getNtzTemplate](context) {
    context.commit(mutationTypes.getNtzTemplateStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .getNtzTemplate()
        .then((response) => {
          context.commit(mutationTypes.getNtzTemplateSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getNtzTemplateFailure)
        })
    })
  },

  [actionTypes.getNtzTemplateSchoolId](context, params) {
    context.commit(mutationTypes.getNtzTemplateSchoolIdStart)
    return new Promise((resolve) => {
      apiNtzTemplate
        .getNtzsTemplateBySchoolId(params)
        .then((response) => {
          context.commit(mutationTypes.getNtzTemplateSchoolIdSuccess, response)
          resolve(response)
        })
        .catch(() => {
          context.commit(mutationTypes.getNtzTemplateSchoolIdFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
